<div class="selectable-list">
  @if (searchable) {
    <sdc-input
      label="Search"
      name="gs-selectable-list-search"
      placeholder="Search"
      [control]="searchControl" />
  }

  <div class="selectable-list-items">
    @for (item of visibleItems; track getItemId(item)) {
      <div
        class="selectable-list-item"
        [class.selectable-list-item-disabled]="isItemDisabled(item)"
        [attr.data-cy]="'gs-selectable-list-row-' + getItemId(item)"
        (click)="onRowClick($event, item)">
        <sdc-checkbox
          class="selectable-list-check"
          labelPosition="right"
          [label]="''"
          [name]="checkboxName(item)"
          [control]="checkboxControl(item)" />
        @if (itemImage(item)) {
          <img class="selectable-list-image" [src]="itemImage(item)" alt="" />
        }
        <div class="selectable-list-copy">
          <label class="selectable-list-title" [for]="checkboxName(item)">
            {{ itemTitle(item) }}
          </label>
          @if (itemSubtitle(item)) {
            <span class="selectable-list-subtitle">{{
              itemSubtitle(item)
            }}</span>
          }
        </div>
      </div>
    }
  </div>

  <sdc-pagination
    [page]="paginationPage"
    [totalItems]="paginationTotal"
    [pageSize]="pageSize"
    [label]="''"
    (pageChange)="onPageChange($event)" />

  @if (loading) {
    <gs-loader
      mode="contained"
      class="selectable-list-loader"
      data-cy="gs-selectable-list-loading" />
  }
</div>
